import { Box } from '@apia/theme';
import { objects } from '../../../../../objects/constants';
import { TRoles } from '../../../../../objects/costs/activities/structure';
import { RolesHoursDetails } from './RolesHoursDetails';

export const hoursPerSquare = 40;

export const RolesHoursCount = () => {
  const count = window.analysisTree.costs.schedule.useRolesHours();
  const length = count.rolesBlackBoxTester.length;

  return (
    <Box className="proposal__weeks__details">
      {new Array<number>(length).fill(1).map((_, i) => {
        return (
          <RolesHoursDetails
            details={
              Object.fromEntries(
                Object.entries(count).map(([name, value]) => [name, value[i]]),
              ) as Record<TRoles, number>
            }
            label={objects.labels.scheduleFromTo(
              i * window.analysisTree.costs.schedule.daysPerSquare,
              (i + 1) * window.analysisTree.costs.schedule.daysPerSquare,
            )}
            key={i}
          />
        );
      })}
    </Box>
  );
};
